module.exports = __webpack_public_path__ + "img/FW_MoonAndStarSword.df5f9aa9.png";